import React, { useState } from 'react';
import debounce from 'lodash.debounce';
import {BannerType, EventListItem, EventsGroup} from '../interfaces';
import EventItem from './EventItem';
import './event-list.scss';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Banner from "../common/Banner";
import Maintenance from '../FrontPage/maintenance';
const itemsList = process.env.REACT_APP_LIMIT_STEP;

type EventListProps = {
    banners: BannerType[];
    filters: any;
    data: any;
}

const RenderBannerInList = (props:{banners: BannerType[]}) => {
    const {banners} = props;
    return <div className="in-list-banners">
        <Banner banners={banners} />
    </div>
}
const RenderGroup = (props: any) => {
    const { group, isLast, filters, banners, showDate } = props;

    return (<div>
        {showDate && <div className="date-group" data-timestamp={group.sortKey}>{group.date}</div>}
        {group.events.map((event: EventListItem, idx: number) => {
            if (idx === 1 && banners && banners.length) {
                return <RenderBannerInList key={idx} banners={banners}/>
            } else {
                return <EventItem filters={filters} event={event} key={idx} isLast={isLast}/>
            }
        })}

    </div>)
}
const EventList = (props: any) => {
    const {data, filters, banners} = props;
    const [ showGoTop, setShowGoTop ] = useState(false);
    window.onscroll = debounce(() => {
        if (document.documentElement.scrollTop > 229) {
            setShowGoTop(true);
        } else {
            setShowGoTop(false);
        }
    }, 90);

    if (!data || !data.events) return null;
    let bannerPos = Math.floor(itemsList ? parseInt(itemsList) /2 : 10);
    /// Math.min(( itemsList ? Math.floor(parseInt(itemsList) /2 ) : 10), Math.floor(data.events.length / 2) )
    let evNumber = 0;
    let showInGroup = 0;
    let groupDate: string = '';
    if (data.events) {
        let pos = 0
        data.events.forEach((ev:any, idx: number) => {
            pos = (idx+1) * ev.events.length;
            if (pos > bannerPos) {
                if (!showInGroup) {
                    showInGroup = idx+1;
                }
            }
            evNumber = evNumber + ev.events.length;
        })
    }
    if (evNumber < 20) {
        bannerPos = Math.floor(evNumber / 2);
    }

    return <div className='event-list'>
        {/* <Maintenance /> */}
        {data.events.map((el: EventsGroup, idx: number) => {
            let showDate = false;
            if (groupDate !== el.date) {
                groupDate = el.date
                showDate = true;
            }

            if (idx === showInGroup-1 && banners && banners.length )  {

                return <React.Fragment>
                 <RenderGroup banners={banners} filters={filters} group={el} key={idx} groupNumber={idx}
                                    isLast={data.events.length === idx + 1} showDate={showDate}/>
                </React.Fragment>
            } else {
                return <RenderGroup filters={filters} group={el} key={idx} groupNumber={idx}
                                    isLast={data.events.length === idx + 1} showDate={showDate}/>
            }
        })}
            { showGoTop &&
            <div className="go-top-ac-btn" onClick={ () => {window.scrollTo(0, 0)}}>
                <FontAwesomeIcon icon={faChevronUp as any} />
            </div> }
        </div>
}

export default EventList;
